namespace ReportWesen {
    // Report Status abfragen
    export const RWStatus = '/?ajax=RWDefault&action=state';
    // Aktuellen Report beenden
    export const RWStop = '/?ajax=RWDefault&action=stop';
    // Form Report erstellen
    export const RWFormReportCreate = '/?ajax=RWFormStart&form=';
    // Form Report speichern
    export const RWFormReportSave = '/?ajax=RWDefault&action=save';
    export const RWIso2Utf = '/?ajax=RWDefault&action=iso2utf&url='
    // Form Action
    export const RWForm = '/?ajax=RWFormAction&form=';
    export const RWFormSave = '/?ajax=RWFormCreate&action=';
    export const RWGExport = '/?ajax=RWDefault&action=gGxport';

}
export = ReportWesen;
